import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock, Mail, Loader2, TrendingUp } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { useToast } from '../hooks/use-toast';
import api from '../lib/api';

const AdminLogin = () => {
  const navigate = useNavigate();
  const { toast } = useToast();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post('/auth/login', { email, password });
      localStorage.setItem('admin_token', data.access_token);
      localStorage.setItem('admin_user', JSON.stringify(data.user));
      toast({ title: 'Welcome back!', description: `Logged in as ${data.user.name}` });
      navigate('/admin/dashboard');
    } catch (err) {
      toast({ title: 'Login Failed', description: err.response?.data?.detail || 'Invalid credentials', variant: 'destructive' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-emerald-900 via-green-900 to-emerald-950 px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="inline-flex w-16 h-16 bg-gradient-to-br from-emerald-400 to-green-600 rounded-2xl items-center justify-center mb-4 shadow-2xl rotate-3">
            <TrendingUp className="h-8 w-8 text-white" />
          </div>
          <h1 className="text-3xl font-bold text-white mb-2">FounderScale Admin</h1>
          <p className="text-green-200">Sign in to manage your platform</p>
        </div>

        <Card className="border-none shadow-2xl">
          <CardContent className="p-8">
            <form onSubmit={handleSubmit} className="space-y-5">
              <div>
                <Label htmlFor="email" className="text-gray-700 font-semibold mb-2 block">Email</Label>
                <div className="relative">
                  <Mail className="absolute left-3 top-1/2 -translate-y-1/2 h-5 w-5 text-gray-400" />
                  <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="login-email"
                    placeholder="info@founderscalecapital.com" className="pl-11 border-gray-300 focus:border-emerald-500" />
                </div>
              </div>
              <div>
                <Label htmlFor="password" className="text-gray-700 font-semibold mb-2 block">Password</Label>
                <div className="relative">
                  <Lock className="absolute left-3 top-1/2 -translate-y-1/2 h-5 w-5 text-gray-400" />
                  <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="login-password"
                    placeholder="Enter password" className="pl-11 border-gray-300 focus:border-emerald-500" />
                </div>
              </div>
              <Button type="submit" disabled={loading} data-testid="login-submit"
                className="w-full bg-gradient-to-r from-emerald-500 to-green-600 hover:from-emerald-600 hover:to-green-700 text-white py-6 font-bold text-lg disabled:opacity-60">
                {loading ? (<><Loader2 className="mr-2 h-5 w-5 animate-spin" />Signing in...</>) : 'Sign In'}
              </Button>
            </form>
          </CardContent>
        </Card>

        <p className="text-center text-green-200/60 text-sm mt-6">Authorized access only</p>
      </div>
    </div>
  );
};

export default AdminLogin;
